(function () {
  if (window.__o2tNewsletterDupCheckInit) return;
  window.__o2tNewsletterDupCheckInit = true;

  var DUPLICATE_CHECK_URL = 'https://patient-bar-27bc.ecommerce-f16.workers.dev/';
  var bypassForms = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;
  var bypassFallbackList = [];

  function shouldBypass(form) {
    if (bypassForms) return bypassForms.has(form);
    return bypassFallbackList.indexOf(form) !== -1;
  }

  function markBypass(form) {
    if (bypassForms) { bypassForms.add(form); return; }
    bypassFallbackList.push(form);
  }

  function clearBypass(form) {
    if (bypassForms) { bypassForms.delete(form); return; }
    var idx = bypassFallbackList.indexOf(form);
    if (idx !== -1) bypassFallbackList.splice(idx, 1);
  }

  function resubmitForReal(form, submitButton) {
    markBypass(form);
    if (typeof form.requestSubmit === 'function') {
      // requestSubmit fires a genuine 'submit' event and runs the normal
      // submission pipeline (including any other theme/app logic that needs
      // to run on submit), unlike the low-level submit() method.
      form.requestSubmit(submitButton || undefined);
    } else {
      // Older browsers without requestSubmit support: fall back to submit(),
      // which still works for a plain, non-duplicate signup.
      HTMLFormElement.prototype.submit.call(form);
    }
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[id^="ContactSubscribe-"]')) return;

    if (shouldBypass(form)) {
      // This is our own re-triggered submission after a clean duplicate check.
      // Let it proceed untouched so any other required submit-time logic runs.
      clearBypass(form);
      return;
    }

    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput ? emailInput.value.trim() : '';
    if (!email) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    fetch(DUPLICATE_CHECK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (submitButton) submitButton.disabled = false;
        if (data && data.alreadySubscribed) {
          showAlreadySubscribed(form);
        } else {
          resubmitForReal(form, submitButton);
        }
      })
      .catch(function () {
        // Fail open: never block a real signup if the check itself fails.
        if (submitButton) submitButton.disabled = false;
        resubmitForReal(form, submitButton);
      });
  }

  function hideIfPresent(el) {
    if (!el) return;
    el.classList.add('hidden');
    el.style.display = 'none';
  }

  function showAlreadySubscribed(form) {
    // Hide any leftover success/validation-error messages that Shopify may
    // have rendered into this page from an earlier real submission (a full
    // page reload keeps that markup in the DOM). Only the "already
    // subscribed" message should be visible.
    var successElement = form.querySelector('[id*="Newsletter-success--"]');
    hideIfPresent(successElement);
    var validationErrorElement = form.querySelector('[id^="Newsletter-error--"]');
    hideIfPresent(validationErrorElement);

    var messageElement = form.querySelector('[id*="Newsletter-error-subscribed"]');
    if (messageElement) {
      messageElement.classList.remove('hidden');
      messageElement.style.display = '';
    }

    var modalEl = form.querySelector('[id*="NewsletterAlertModal-"]');
    // Always open the alert modal for a duplicate-email result. Do NOT gate
    // this on window.isNewsletterModalShow -- that flag is set by the theme's
    // own success-modal-on-page-load logic and, once true, would silently
    // block us from ever opening the modal again for this page view.
    if (modalEl && modalEl.show) modalEl.show();
  }

  document.addEventListener('submit', handleSubmit, true);
})();
